module.exports = __webpack_public_path__ + "img/Linux.6b67a4e7.webp";